var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ServicesCard',{attrs:{"cardHeadline":_vm.houseName ? `Saker bygg ${_vm.houseName}` : 'Prosjekt saker'},on:{"click":_vm.click},model:{value:(_vm.services),callback:function ($$v) {_vm.services=$$v},expression:"services"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }